import {Button, Flash, NavList, Spinner} from '@primer/react'

import type {StackSectionEntryType} from '../../../helpers/merge-box-status-calculator/stack-section-status'
import {MergeSectionActions} from './MergeSectionActions'
import {MergeBoxSectionHeader} from '../common/MergeBoxSectionHeader'
import {EntryStatusIcon} from '../stack-section/EntryStatusIcon'
import {useDisableAutoMergeMutation} from '../../../hooks/mutations/use-disable-auto-merge-mutation'
import {useState} from 'react'
import {StopIcon} from '@primer/octicons-react'

export function StackMergeInProgress({
  entries,
  viewerCanDisableAutoMerge,
}: {
  entries: StackSectionEntryType[]
  viewerCanDisableAutoMerge: boolean
}) {
  const [errorMessage, setErrorMessage] = useState<string | undefined>()
  const {mutate: disableAutoMerge, isPending} = useDisableAutoMergeMutation({
    onError: (e: Error) => {
      setErrorMessage(e.message)
    },
  })

  const handleDisableAutoMerge = () => {
    if (isPending) return
    setErrorMessage(undefined)
    disableAutoMerge()
  }

  return (
    <>
      {errorMessage && (
        <Flash className="tmp-mx-3 my-2" variant="danger">
          <StopIcon className="mr-2" />
          {errorMessage}
        </Flash>
      )}
      <MergeSectionActions>
        <MergeSectionActions.Slot>
          <div className="flex-1">
            <MergeBoxSectionHeader
              title={'Stack is merging...'}
              icon={<Spinner size="small" className="mt-1" />}
              rightSideContent={
                <Button
                  disabled={!viewerCanDisableAutoMerge}
                  onClick={handleDisableAutoMerge}
                  loading={isPending}
                  loadingAnnouncement="Disabling stack merge"
                >
                  Disable stack merge
                </Button>
              }
            />
            <NavList aria-label="Pull requests in this stack">
              {entries.map(e => {
                if (e.position === 'AFTER') return null
                if (e.status === 'IRRELEVANT_MERGED') return null
                return (
                  <NavList.Item key={e.pull.number} href={e.pull.url} aria-current={e.position === 'CURRENT'}>
                    <NavList.LeadingVisual>
                      <EntryStatusIcon entry={e} rebaseState={'SUCCEEDED'} />
                    </NavList.LeadingVisual>
                    <span>{e.pull.title}</span> <span className="fgColor-muted">#{e.pull.number}</span>
                  </NavList.Item>
                )
              })}
            </NavList>
          </div>
        </MergeSectionActions.Slot>
      </MergeSectionActions>
    </>
  )
}
